module.exports = __webpack_public_path__ + "assets/img/money-bg-icon.bdd8473c.png";